import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Alexandria, IBM_Plex_Mono, IBM_Plex_Sans_Arabic } from 'next/font/google'
import { SettingsProvider } from '@/components/app/settings-provider'
import { ToastProvider } from '@/components/app/toast'

const sans = IBM_Plex_Sans_Arabic({
    subsets: ['arabic', 'latin'],
    weight: ['300', '400', '500', '600', '700'],
    display: 'swap'
})

const heading = Alexandria({
    subsets: ['arabic', 'latin'],
    display: 'swap'
})

const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <SettingsProvider>
                <ToastProvider>
                    <Component {...pageProps} />
                </ToastProvider>
            </SettingsProvider>
        </div>
    )
}

export default App
